import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { Radio } from 'lucide-react';
import LiveListenerBadge from './LiveListenerBadge';

/**
 * Live-radio marquee that shows the most recent play across the app.
 * Refreshes every 30s. Silent when nothing is playing.
 */
const NowPlayingTicker = () => {
  const [song, setSong] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await api.get('/now-playing-ticker');
        if (alive) setSong(data?.song || null);
      } catch { /* noop */ }
    };
    load();
    const t = setInterval(load, 30000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!song) return null;

  const line = `${song.title} · ${song.artist}`;
  return (
    <div
      data-testid="ticker"
      className="relative overflow-hidden border-b border-[#3D1A1A] bg-gradient-to-r from-[#220A0A]/80 via-[#3D1A1A]/50 to-[#220A0A]/80 backdrop-blur-md"
    >
      <div className="max-w-5xl mx-auto flex items-center gap-3 h-8 px-4 text-xs">
        <div className="flex items-center gap-1.5 shrink-0 pr-2 border-r border-[#3D1A1A] text-[#FF007F] font-bold uppercase tracking-[0.2em]">
          <Radio className="w-3 h-3 animate-pulse" />
          <span className="hidden sm:inline">On Air</span>
          <span className="sm:hidden">LIVE</span>
        </div>
        <div className="sm:hidden shrink-0 pr-2 border-r border-[#3D1A1A]">
          <LiveListenerBadge variant="inline" />
        </div>
        <div className="flex-1 overflow-hidden relative">
          <div className="marquee-inner">
            <span className="pr-16 whitespace-nowrap text-[#FFF3E0]">
              <span className="text-[#FFB800] mr-1">Abhi Patna mein baj raha hai —</span>
              {line}
              <span className="mx-6 text-[#3D1A1A]">✦</span>
            </span>
            <span className="pr-16 whitespace-nowrap text-[#FFF3E0]">
              <span className="text-[#FFB800] mr-1">Abhi Patna mein baj raha hai —</span>
              {line}
              <span className="mx-6 text-[#3D1A1A]">✦</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NowPlayingTicker;
